/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Hard_SInputs */

const en_funnel_ob_goal_hard_s = /** @type {(inputs: Funnel_Ob_Goal_Hard_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dyslexia, ADHD, tired eyes`)
};

const es_funnel_ob_goal_hard_s = /** @type {(inputs: Funnel_Ob_Goal_Hard_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dislexia, TDAH, vista cansada`)
};

/**
* | output |
* | --- |
* | "Dyslexia, ADHD, tired eyes" |
*
* @param {Funnel_Ob_Goal_Hard_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_hard_s = /** @type {((inputs?: Funnel_Ob_Goal_Hard_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Hard_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_hard_s(inputs)
	return en_funnel_ob_goal_hard_s(inputs)
});